export default __webpack_public_path__ + "static/media/postmates-logo.b51cfe29.png";